import './Menu.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {Link} from 'react-router-dom'
// import blkBgLogo from '../../assets/logowithBlackBg.png'
import companylogo from '../../assets/kmpslogo.png'
import Logo from './logo/glowlogo'
const Menu=(props)=>{
    return(
      
        <div className='menu-main'>
          <div className='menu-logo-info'>
              <div className='menu-logo floating'> 
                  <img style={{}} src={companylogo} />
                  </div>
                  <div className='menu-logo-text-container'>
                    <p className='menu-logo-text-header'>KMPS DIGI INFRA PRIVATE LIMITED</p>
                    <p className='menu-logo-text-sub-header'>DRIVING THE FUTURE WITH EMBEDDED INTELLIGENCE</p>
                  </div>
          </div>
             
                <div className='menu-option-container'>
                  <Link to={'/'} style={{textDecoration:"none", textTransform:"none"}} ><div  className={`menu-option ${props.page == 'HOME'? "menu-option-active" : ""}`}>Home</div></Link>  
                  {/* <Link to={'/'} style={{textDecoration:"none", textTransform:"none"}} ><div className='menu-option'>About</div></Link>  */}
                  <Link to={'/service'} style={{textDecoration:"none", textTransform:"none"}} > <div className={`menu-option ${props.page == 'SERVICE'? "menu-option-active" : ""}`}>Solutions</div></Link> 
                  <Link to={'/clients'} style={{textDecoration:"none", textTransform:"none"}} > <div className={`menu-option ${props.page == 'CLIENTS'? "menu-option-active" : ""}`}>Clients</div></Link> 
                  {/* <Link to={'/projects'} style={{textDecoration:"none", textTransform:"none"}} ><div className={`menu-option ${props.page == 'PROJECT'? "menu-option-active" : ""}`}>Products</div></Link>  */}
                  {/* <div className='menu-option' style={{display:"flex", alignItems:"end"}}>Pages<KeyboardArrowDownIcon style={{fontSize:"0.9rem"}}/></div> */}
                  <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} ><div className={`menu-option ${props.page == 'CONTACT'? "menu-option-active" : ""}`}>Contact</div></Link> 
                </div>
                <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} > 
                 <button style={{display:"none"}} className='menu-get-it-support'>Get it support</button></Link>                
        </div>
    )
}

export default Menu